/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./target.defs.js";
export { main as default } from "./target.defs.js";
